export const kycStatusEnum = ['APPROVED', 'REJECTED', 'PENDING', 'FLAGGED']